import { render, staticRenderFns } from "./testPaper.vue?vue&type=template&id=a577a130&scoped=true"
import script from "./testPaper.vue?vue&type=script&lang=js"
export * from "./testPaper.vue?vue&type=script&lang=js"
import style0 from "./testPaper.vue?vue&type=style&index=0&id=a577a130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a577a130",
  null
  
)

export default component.exports